/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Application_Company_Inactive_ErrorInputs */

const en_application_company_inactive_error = /** @type {(inputs: Application_Company_Inactive_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This position is no longer available — the company has been archived. Please go back and choose a different position.`)
};

const de_application_company_inactive_error = /** @type {(inputs: Application_Company_Inactive_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Stelle ist nicht mehr verfügbar – das Unternehmen wurde archiviert. Bitte gehen Sie zurück und wählen Sie eine andere Stelle.`)
};

/**
* | output |
* | --- |
* | "This position is no longer available — the company has been archived. Please go back and choose a different position." |
*
* @param {Application_Company_Inactive_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const application_company_inactive_error = /** @type {((inputs?: Application_Company_Inactive_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Application_Company_Inactive_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_application_company_inactive_error(inputs)
	return en_application_company_inactive_error(inputs)
});